import styled from "styled-components"

export const Introduction = styled.div`
  p:first-child {
    margin 0;
  }
`

export const FeatureOverlay = styled.div`
   {
    justify-content: center;
    align-items: center;
    bottom: 0;
    right: 0;
    position: absolute;
    background: #000;
  }
`

export const ThumbnailOverlay = styled.div`
   {
    justify-content: center;
    align-items: center;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    position: absolute;
    background: rgba(32, 40, 46, 0.42);
  }
`
